import { render, staticRenderFns } from "./DataSuccessMetrics.vue?vue&type=template&id=65d7f6d2&"
import script from "./DataSuccessMetrics.vue?vue&type=script&lang=js&"
export * from "./DataSuccessMetrics.vue?vue&type=script&lang=js&"
import style0 from "./DataSuccessMetrics.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d7f6d2')) {
      api.createRecord('65d7f6d2', component.options)
    } else {
      api.reload('65d7f6d2', component.options)
    }
    module.hot.accept("./DataSuccessMetrics.vue?vue&type=template&id=65d7f6d2&", function () {
      api.rerender('65d7f6d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/DataSuccessMetrics.vue"
export default component.exports